import { editorRoleFor } from "@msuite/citadel";
import { useCitadel } from "@/hooks/use-citadel";

/**
 * Which side of the attendance editability rule the caller stands on — the same question the
 * server answers before it writes: `"admin"` when the caller's `update Attendance` carries no
 * condition (the owner and the admin role), who may correct any entry; `"user"` for everybody
 * whose right is bound to their own rows, who may correct their own entry only while it is
 * pending. Fed to `getIsAttendanceEditable`, so the controls hide exactly what the server would
 * refuse. While the rules are still loading the answer is `"user"`, the narrower of the two.
 */
export function useAttendanceEditorRole(): "admin" | "user" {
	const { citadel } = useCitadel();
	return editorRoleFor(citadel, "Attendance");
}
